import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface MapDevicePanel {
  deviceId: string;
  flowRate: string;
  pos: string;
  waterLevel: string;
  velocity: string;
  publish: string;
  areaName: string;
  riverName: string;
}

interface MapDevicePanelsState {
  panels: MapDevicePanel[];
}

const MAX_OPEN_PANELS = 4;

const initialState: MapDevicePanelsState = {
  panels: [],
};

export const mapDevicePanelsSlice = createSlice({
  name: 'mapDevicePanels',
  initialState,
  reducers: {
    openMapDevicePanel: (state, action: PayloadAction<MapDevicePanel>) => {
      const existingIndex = state.panels.findIndex((panel) => panel.deviceId === action.payload.deviceId);

      if (existingIndex >= 0) {
        state.panels.splice(existingIndex, 1);
      } else if (state.panels.length >= MAX_OPEN_PANELS) {
        state.panels.pop();
      }

      state.panels.unshift(action.payload);
    },
    closeMapDevicePanel: (state, action: PayloadAction<string>) => {
      state.panels = state.panels.filter((panel) => panel.deviceId !== action.payload);
    },
    syncMapDevicePanel: (state, action: PayloadAction<MapDevicePanel>) => {
      const existingIndex = state.panels.findIndex((panel) => panel.deviceId === action.payload.deviceId);
      if (existingIndex >= 0) state.panels[existingIndex] = action.payload;
    },
    closeAllMapDevicePanels: (state) => {
      state.panels = [];
    },
  },
});

export const { openMapDevicePanel, closeMapDevicePanel, closeAllMapDevicePanels, syncMapDevicePanel } =
  mapDevicePanelsSlice.actions;
export const mapDevicePanelsReducer = mapDevicePanelsSlice.reducer;
